// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-fab {
  display: flex;
  position: fixed;
  bottom: 25px;
  right: 25px;
}
ion-fab ion-fab-button {
  height: 50px;
  --box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1),
  	0 2px 4px -2px rgb(0 0 0 / 0.1);
}
ion-fab ion-icon {
  font-size: 20px;
  --ionicon-stroke-width: 70px;
}

.lock-btn {
  width: 50px;
}

.type-btn {
  width: 140px !important;
  --border-radius: 100px;
  margin-right: 10px;
  --background: white;
  --background-hover: white;
  --background-activated: white;
  --color: var(--ion-color-dark);
}
.type-btn ion-text {
  display: flex;
}

.empty-data {
  height: 90vh;
}

.hide-diagram {
  display: none;
}

ion-header ion-toolbar {
  --padding-start: 16px;
  --padding-end: 16px;
}

.menu {
  display: flex;
  gap: 16px;
}

.menu ion-card {
  transition: 250ms;
  border: 1.5px solid transparent;
  cursor: pointer;
  margin: 8px 0;
  display: flex;
}
.menu ion-card.active {
  box-shadow: 0 0 6px 1px rgba(149, 154, 165, 0.31);
}
.menu ion-card ion-card-content {
  padding: 12px 24px !important;
}
.menu ion-card ion-card-content h4 {
  font-weight: 600;
  font-size: 14px;
  padding-left: 0;
  color: var(--ion-color-dark);
}

dx-diagram {
  height: calc(100% - 84.8px) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/tables/transfer-tickets/transfer-tickets.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AACD;AACC;EACC,YAAA;EACA;kCAAA;AAEF;AAEC;EACC,eAAA;EACA,4BAAA;AAAF;;AAIA;EACC,WAAA;AADD;;AAIA;EACC,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;EACA,8BAAA;AADD;AAGC;EACC,aAAA;AADF;;AAKA;EACC,YAAA;AAFD;;AAKA;EACC,aAAA;AAFD;;AAMC;EACC,qBAAA;EACA,mBAAA;AAHF;;AAOA;EACC,aAAA;EACA,SAAA;AAJD;;AAQC;EACC,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;AALF;AAOE;EACC,iDAAA;AALH;AAQE;EACC,6BAAA;AANH;AAQG;EACC,gBAAA;EACA,eAAA;EACA,eAAA;EACA,4BAAA;AANJ;;AAYA;EACC,sCAAA;AATD","sourcesContent":["ion-fab {\n\tdisplay: flex;\n\tposition: fixed;\n\tbottom: 25px;\n\tright: 25px;\n\n\tion-fab-button {\n\t\theight: 50px;\n\t\t--box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1),\n\t\t\t0 2px 4px -2px rgb(0 0 0 / 0.1);\n\t}\n\n\tion-icon {\n\t\tfont-size: 20px;\n\t\t--ionicon-stroke-width: 70px;\n\t}\n}\n\n.lock-btn {\n\twidth: 50px;\n}\n\n.type-btn {\n\twidth: 140px !important;\n\t--border-radius: 100px;\n\tmargin-right: 10px;\n\t--background: white;\n\t--background-hover: white;\n\t--background-activated: white;\n\t--color: var(--ion-color-dark);\n\n\tion-text {\n\t\tdisplay: flex;\n\t}\n}\n\n.empty-data {\n\theight: 90vh;\n}\n\n.hide-diagram {\n\tdisplay: none;\n}\n\nion-header {\n\tion-toolbar {\n\t\t--padding-start: 16px;\n\t\t--padding-end: 16px;\n\t}\n}\n\n.menu {\n\tdisplay: flex;\n\tgap: 16px;\n}\n\n.menu {\n\tion-card {\n\t\ttransition: 250ms;\n\t\tborder: 1.5px solid transparent;\n\t\tcursor: pointer;\n\t\tmargin: 8px 0;\n\t\tdisplay: flex;\n\n\t\t&.active {\n\t\t\tbox-shadow: 0 0 6px 1px rgb(149 154 165 / 31%);\n\t\t}\n\n\t\tion-card-content {\n\t\t\tpadding: 12px 24px !important;\n\n\t\t\th4 {\n\t\t\t\tfont-weight: 600;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tpadding-left: 0;\n\t\t\t\tcolor: var(--ion-color-dark);\n\t\t\t}\n\t\t}\n\t}\n}\n\ndx-diagram {\n\theight: calc(100% - 84.8px) !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
